import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { PrivacySEO } from '../components/SEO';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <PrivacySEO />
      <Header />
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <h1 className="font-playfair text-4xl md:text-5xl font-bold mb-12 text-[#1a1a1a]">
          Privacy Policy
        </h1>
        
        <div className="space-y-8 font-manrope text-sm">
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">1. Information We Collect</h2>
            <p className="text-[#737373]">
              We collect personal information including name, email, phone, company details, and payment information to process orders and deliver services.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside text-[#737373] space-y-1 ml-4">
              <li>Process orders and payments</li>
              <li>Communicate order status and updates</li>
              <li>Generate invoices and receipts</li>
              <li>Improve our services</li>
              <li>Send occasional marketing communications (with consent)</li>
            </ul>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">3. Data Security</h2>
            <p className="text-[#737373]">
              We implement industry-standard security measures to protect your data. Payment processing is handled securely via Razorpay.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">4. Third-Party Sharing</h2>
            <p className="text-[#737373]">
              We share relevant information with media outlets only as necessary to fulfill orders. We do not sell or rent personal information to third parties.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">5. Your Rights</h2>
            <p className="text-[#737373]">
              You have the right to access, correct, or delete your personal information. Contact us at privacy@businessmintpr.com for data requests.
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Privacy;